export default __webpack_public_path__ + "static/media/A_lopetus3.d7f74b13.mp3";